module.exports = __webpack_public_path__ + "media/images/talent/case5-icon02-4f62df9aa3466820602b79eecf3bdd0b.png";